import { Icon } from '@/ui'
import { cx } from '@/ui/cx'
import { S } from './strings'
import styles from './CpfGate.module.css'

export type CpfVerdict = 'idle' | 'checking' | 'match' | 'mismatch' | 'error'

interface CpfGateProps {
  value: string
  onChange: (value: string) => void
  /** Verdict of the server-side check (`verify-tax-id`). The browser never holds the CPF. */
  verdict: CpfVerdict
}

export function CpfGate({ value, onChange, verdict }: CpfGateProps) {
  const answered = verdict === 'match' || verdict === 'mismatch'
  const match = verdict === 'match'
  return (
    <div className={cx(styles.gate, answered && (match ? styles.ok : styles.bad))}>
      <div>
        <div className={styles.title}>{S.gateTitle}</div>
        <div className={styles.help}>{S.gateHelp}</div>
      </div>
      <div className={styles.entry}>
        <input
          className={cx(styles.input, answered && (match ? styles.inputOk : styles.inputBad))}
          value={value}
          onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 4))}
          inputMode="numeric"
          autoComplete="off"
          placeholder="0000"
          aria-label={S.gateTitle}
          aria-invalid={verdict === 'mismatch' || undefined}
          data-autofocus=""
        />
        <span
          role="status"
          className={cx(styles.result, verdict === 'mismatch' && styles.resultBad)}
        >
          {verdict === 'checking' && S.gateChecking}
          {verdict === 'error' && S.gateError}
          {answered && (
            <>
              <Icon name={match ? 'check' : 'close'} size={16} />
              {match ? S.gateMatch : S.gateMismatch}
            </>
          )}
        </span>
      </div>
    </div>
  )
}
